<table class="layout-fixed striped">
  <colgroup>
    <col class="width-20" />
    <col class="width-15" />
    <col class="width-15" />
    <col class="width-20" />
    <col class="width-15" />
    <col class="width-15" />
  </colgroup>
  <thead>
    <tr>
      <th colspan="6">
        <h3>{{eventLogPrefix}}{{reportLogOfEvent.activityStream}}</h3>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr class="secondary-header">
      <td>{{StaticMessage.ActivityGroupColumn | staticMessage}}</td>
      <td class="text-center" i18n="@@report.reportEventsLogWithGroupsAndActivities.colTotalDurationToday">
        Total duration today
      </td>
      <td class="text-center" i18n="@@report.reportEventsLogWithGroupsAndActivities.colAccumulatedDurationToDate">
        Accumulated duration to date
      </td>
      <td>{{StaticMessage.ActivityColumn | staticMessage}}</td>
      <td class="text-center" i18n="@@report.reportEventsLogWithGroupsAndActivities.colTotalDurationToday">
        Total duration today
      </td>
      <td class="text-center" i18n="@@report.reportEventsLogWithGroupsAndActivities.colAccumulatedDurationToDate">
        Accumulated duration to date
      </td>
    </tr>
    <tr *ngFor="let logEvent of reportLogOfEvent.reportOfEventLog | sort: 'activityGroup': 'asc'">
      <td class="vertical-align-middle">{{logEvent.activityGroup}}</td>
      <td class="text-center vertical-align-middle">
        <span class="text-middle-right-aligned">{{logEvent.totalDurationToday}}</span>
      </td>
      <td class="text-center vertical-align-middle border-right">
        <span class="text-middle-right-aligned">{{logEvent.accumulatedDurationToDate}}</span>
      </td>
      <ng-container *ngLet="(logEvent.activities | sort: 'activity': 'asc') as activities">
        <td class="p-0" colspan="3">
          <table class="inner-table layout-fixed">
            <colgroup>
              <col class="width-40" />
              <col class="width-30" />
              <col class="width-30" />
            </colgroup>
            <tr *ngFor="let activity of activities">
              <td>{{activity.activity}}</td>
              <td class="text-center">
                <span class="text-middle-right-aligned">{{activity.totalDurationToday}}</span>
              </td>
              <td class="text-center">
                <span class="text-middle-right-aligned">{{activity.accumulatedDurationToDate}}</span>
              </td>
            </tr>
          </table>
        </td>
      </ng-container>
    </tr>
    <tr class="summary-total-row">
      <td class="accent vertical-align-middle">{{StaticMessage.TotalColumn | staticMessage}}</td>
      <td class="accent text-center vertical-align-middle">
        <span class="text-middle-right-aligned">
          {{reportLogOfEvent | sumLogOfEvents : 'totalDurationToday' : true}}
        </span>
      </td>
      <td class="accent text-center vertical-align-middle">
        <span class="text-middle-right-aligned">
          {{reportLogOfEvent | sumLogOfEvents : 'accumulatedDurationToDate' : true}}
        </span>
      </td>
      <td class="accent border-left-total">{{StaticMessage.TotalColumn | staticMessage}}</td>
      <td class="accent text-center">
        <span class="text-middle-right-aligned">
          {{reportLogOfEvent | sumLogOfEvents : 'totalDurationToday' : false}}
        </span>
      </td>
      <td class="accent text-center">
        <span class="text-middle-right-aligned">
          {{reportLogOfEvent | sumLogOfEvents : 'accumulatedDurationToDate' : false}}
        </span>
      </td>
    </tr>
  </tbody>
</table>
